export class IdAndLabel {
  constructor(public id: any, public label: string) {}
  
  public static from<Type>(idKey: keyof Type, labelKey: keyof Type) {
    return (subject: Type) => (new IdAndLabel(subject[idKey], `${subject[labelKey]}`));
  }
}
